import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = {
  key: 0,
  class: "list-body"
}
const _hoisted_3 = { class: "count-item" }
const _hoisted_4 = { class: "result-content" }
const _hoisted_5 = { class: "result-action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString($setup.countdown + 's'), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString($setup.resultContent), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_SubmitButton, {
              text: "CONTINUAR",
              "show-icon": false,
              onClick: $setup.handleBackClick
            }, null, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}